import { ArrowUturnLeftIcon, CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { claimAcademicYear, claimDisplayStatus, claimTypeLabel } from "../../config/claimStatus";
import { formatDateTime } from "../scholarships/review/model";
import { nameOf } from "../bursaries/shared";
import { Button, Modal, Property, StatusBadge } from "../ui";

const ICON = "h-4 w-4";

// A claim's full description and who last decided it, with the review actions its status allows
export default function ClaimDetailModal({ claim, updating, onClose, onChangeStatus }) {
  const pending = claim?.status === "RECEIVED";

  const footer = claim && (
    <div className="flex w-full flex-wrap items-center justify-end gap-3">
      <div className="flex gap-3">
        {pending ? (
          <>
            <Button variant="danger-soft" size="sm" icon={<XMarkIcon className={ICON} />} loading={updating} onClick={() => onChangeStatus(claim, "REJECTED")}>
              Reject claim
            </Button>
            <Button size="sm" icon={<CheckIcon className={ICON} />} loading={updating} onClick={() => onChangeStatus(claim, "APPROVED")}>
              Approve claim
            </Button>
          </>
        ) : (
          <Button variant="soft" size="sm" icon={<ArrowUturnLeftIcon className={ICON} />} loading={updating} onClick={() => onChangeStatus(claim, "RECEIVED")}>
            Revert to pending
          </Button>
        )}
      </div>
    </div>
  );

  return (
    <Modal open={Boolean(claim)} onClose={onClose} title="Claim details" description={claim && `Student: ${claim.registrationNumber}`} footer={footer}>
      {claim && (
        <div className="flex flex-col gap-5">
          <div>
            <Property label="Reg number" value={claim.registrationNumber} />
            <Property label="Student" value={nameOf(claim)} />
            <Property label="Institution" value={claim.institution?.name ?? "—"} />
            <Property label="Claim type" value={claimTypeLabel(claim.claimType)} />
            <Property label="Academic year" value={claimAcademicYear(claim)} />
            <Property label="Submitted" value={formatDateTime(claim.createdAt)} />
            <Property label="Status" value={<StatusBadge status={claimDisplayStatus(claim.status)} />} />
            {claim.decidedBy && <Property label="Decided by" value={`${claim.decidedBy.name ?? "HEC staff"} · ${formatDateTime(claim.decidedAt)}`} />}
          </div>
          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-500">Claim description</h4>
            <p className="min-h-20 whitespace-pre-wrap break-words rounded-lg border border-slate-100 bg-slate-50 p-4 text-sm leading-relaxed text-slate-700">
              {claim.description || <span className="italic text-slate-400">No description provided</span>}
            </p>
          </div>
        </div>
      )}
    </Modal>
  );
}
